<div class="dropdown">
  <button type="button" class="dropdown-trigger" (click)="toggleOpen()">
    <span class="zone-label" *ngIf="selectedLabel; else placeholderTpl">{{ selectedLabel }}</span>
    <ng-template #placeholderTpl>
      <span class="placeholder">{{ placeholder }}</span>
    </ng-template>
    <span class="dropdown-arrow" [class.open]="open">▾</span>
  </button>

  <div class="dropdown-panel" *ngIf="open">
    <input
      class="filter-input"
      type="text"
      [(ngModel)]="filter"
      placeholder="Search city, zone or offset — e.g. Bengaluru, Kolkata, +05:30"
      (click)="$event.stopPropagation()"
    />
    <div class="options-list">
      <button
        type="button"
        class="option-item"
        *ngFor="let opt of filteredOptions"
        [class.active]="isSelected(opt)"
        (click)="choose(opt)"
      >
        {{ label(opt) }}
      </button>
      <div class="empty-hint" *ngIf="filteredOptions.length === 0">No matches</div>
    </div>
  </div>
</div>
